import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import SuspenseWrapper from "../SuspenseWrapper";

const UsersPage = lazy(() => import("../../pages/users-roles/UsersPage"));
const RolesPage = lazy(() => import("../../pages/users-roles/RolesPage"));
const RoleEditorPage = lazy(
  () => import("../../pages/users-roles/RoleEditorPage"),
);

export const usersRolesRoutes: RouteObject[] = [
  {
    path: "users-rules/users",
    element: (
      <SuspenseWrapper>
        <UsersPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "users-rules/rules",
    element: (
      <SuspenseWrapper>
        <RolesPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "users-rules/rules/new",
    element: (
      <SuspenseWrapper>
        <RoleEditorPage />
      </SuspenseWrapper>
    ),
  },
  {
    path: "users-rules/rules/:id/edit",
    element: (
      <SuspenseWrapper>
        <RoleEditorPage />
      </SuspenseWrapper>
    ),
  },
];
